import { render, staticRenderFns } from "./DragDropUpload.vue?vue&type=template&id=06f1da8a&scoped=true"
import script from "./DragDropUpload.vue?vue&type=script&lang=js"
export * from "./DragDropUpload.vue?vue&type=script&lang=js"
import style0 from "./DragDropUpload.vue?vue&type=style&index=0&id=06f1da8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1da8a",
  null
  
)

export default component.exports